import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // NDEs list
  ndes: null,
  isFetchingNdes: false,
  fetchNdesError: null,

  // Single NDE instance
  nde: null,
  isFetchingNde: false,
  fetchNdeError: null,
  isCreatingNde: false,
  createNdeError: null,
  isUpdatingNde: false,
  updateNdeError: null,
  isDeletingNde: false,
  deleteNdeError: null
};

const ndesSlice = createSlice({
  name: 'ndes',
  initialState,
  reducers: {
    // Ndes list
    // GET
    ndesFetchStart: state => ({
      ...state,
      isFetchingNdes: true,
      fetchNdesError: null
    }),

    ndesFetchFail: (state, action) => ({
      ...state,
      isFetchingNdes: false,
      ndes: null,
      fetchNdesError: action.payload.error
    }),

    ndesFetchComplete: (state, action) => ({
      ...state,
      isFetchingNdes: false,
      ndes: action.payload,
      fetchNdesError: null
    }),

    // Single NDE instance
    // GET
    ndeFetchStart: state => ({
      ...state,
      isFetchingNde: true,
      fetchNdeError: null
    }),

    ndeFetchFail: (state, action) => ({
      ...state,
      isFetchingNde: false,
      nde: null,
      fetchNdeError: action.payload.error
    }),

    ndeFetchComplete: (state, action) => ({
      ...state,
      isFetchingNde: false,
      nde: action.payload,
      fetchNdeError: null
    }),

    // PUT/PATCH
    ndeUpdateStart: (state) => ({
      ...state,
      isUpdatingNde: true,
      updateNdeError: null
    }),

    ndeUpdateFail: (state, action) => ({
      ...state,
      isUpdatingNde: false,
      updateNdeError: action.payload
    }),

    ndeUpdateComplete: (state) => {
      return {
        ...state,
        isUpdatingNde: false,
        updateNdeError: null
      };
    },

    // POST
    ndeCreateStart: (state) => ({
      ...state,
      isCreatingNde: true,
      createNdeError: null
    }),

    ndeCreateFail: (state, action) => ({
      ...state,
      isCreatingNde: false,
      createNdeError: action.payload
    }),

    ndeCreateComplete: (state) => {
      return {
        ...state,
        isCreatingNde: false,
        createNdeError: null
      };
    },

    // DELETE
    ndeDeleteStart: (state) => ({
      ...state,
      isDeletingNde: true,
      deleteNdeError: null
    }),

    ndeDeleteFail: (state, action) => ({
      ...state,
      isDeletingNde: false,
      deleteNdeError: action.payload
    }),

    ndeDeleteComplete: (state) => {
      return {
        ...state,
        isDeletingNde: false,
        deleteNdeError: null
      };
    },

    ndesClearComplete: (state) => ({
      ...state,
      ...initialState
    })
  }
});

export const ndesActions = ndesSlice.actions;

export default ndesSlice.reducer;
